import React from 'react';
export function Footer() {
  return <footer className="bg-onyx border-t border-gold/20 py-12" data-id="element-152">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-153">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-154">
          {/* Brand */}
          <div data-id="element-155">
            <div className="flex flex-col mb-4" data-id="element-156">
              <span className="font-cinzel text-gold text-xl tracking-widest" data-id="element-157">
                MADAM YAS
              </span>
              <div className="h-px w-32 bg-gold mt-1" data-id="element-158"></div>
            </div>
            <p className="text-silver-muted text-sm leading-relaxed" data-id="element-159">
              Professional Dominance
              <br data-id="element-160" />
              Los Angeles Area
              <br data-id="element-161" />
              Black-Owned Business
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-162">
            <h3 className="text-bone font-cormorant text-lg mb-4" data-id="element-163">
              Quick Links
            </h3>
            <nav className="space-y-2" data-id="element-164">
              <a href="#about" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-165">
                About
              </a>
              <a href="#experiences" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-166">
                Services
              </a>
              <a href="#etiquette" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-167">
                Etiquette
              </a>
              <a href="#faq" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-168">
                FAQ
              </a>
              <a href="#contact" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-169">
                Contact
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div data-id="element-170">
            <h3 className="text-bone font-cormorant text-lg mb-4" data-id="element-171">Contact</h3>
            <div className="space-y-2 text-silver-muted text-sm" data-id="element-172">
              <p data-id="element-173">
                <a href="tel:5625480191" className="hover:text-gold transition-colors" data-id="element-174">
                  562.548.0191
                </a>
              </p>
              <p data-id="element-175">
                <a href="mailto:Cinnabunnsib@gmail.com" className="hover:text-gold transition-colors break-all" data-id="element-176">
                  Cinnabunnsib@gmail.com
                </a>
              </p>
              <p className="pt-4 text-xs" data-id="element-177">
                Sessions by appointment only
                <br data-id="element-178" />
                Screening required
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gold/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-179">
          <p className="text-silver-muted text-xs" data-id="element-180">
            © {new Date().getFullYear()} Madam Yas. All rights reserved.
          </p>
          <p className="text-silver-muted text-xs" data-id="element-181">
            Discretion · Professionalism · Excellence
          </p>
        </div>
      </div>
    </footer>;
}